import { fetchAPI } from "./baseApi";

export async function getHomepageCards() {
  return fetchAPI("/homepage-cards/list", {
    method: "GET",
  });
}

export async function createHomepageCard(data) {
  return fetchAPI("/homepage-cards", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateHomepageCard(id, data) {
  return fetchAPI(`/homepage-cards/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteHomepageCard(id) {
  return fetchAPI(`/homepage-cards/${id}`, {
    method: "DELETE",
  });
}
